// KEEP IDENTICAL WITH DEFAULT BACKGROUND IN CSS
export default "linear-gradient(to right top, #2f6a84, #307795, #3184a6, #3091b7, #2f9fc9, #24a4cb, #15aacd, #00afce, #00adbd, #00aaaa, #00a694, #29a17e)";
